<template>
  <div class="goods-price-button">
    <div class="app-advert-box">
      <div class="app-advert bottom-fixed">
        <!--线下商品价格显示-->
        <div class="content price" v-if="offlineProduct && offlineProduct.case_type == 'group'">
          <p class="price-text price-text_new">
            <span class="number">{{ titleObj.starPrice }}</span>
            <span class="symbol" v-if="titleObj.starPrice > titleObj.endPrice">元</span>
            <span
              class="number"
              style="margin: 0 0.1rem"
              v-if="titleObj.starPrice < titleObj.endPrice"
            >
              -
            </span>
            <span class="number" v-if="titleObj.starPrice < titleObj.endPrice">
              {{ titleObj.endPrice }}
            </span>
            <span class="symbol" v-if="titleObj.starPrice < titleObj.endPrice">元</span>
          </p>
        </div>
        <!--线上商品价格显示-->
        <div class="content price" v-else>
          <!--普通商品-->
          <template v-if="goodsData.usability == 'product'">
            <!-- 有会员价格 -->
            <div v-if="isHasVipPrice">
              <!-- 有会员价资格 -->
              <div v-if="isVipPricePower">
                <p class="price-text price-text_vip_large">
                  <span class="symbol">会员价</span>
                  <span class="number">{{ vipPrice }}</span>
                  <span class="symbol">元</span>
                </p>
                <p class="price-text price-text_old">
                  <span class="number">￥{{ newPrice }}</span>
                </p>
              </div>
              <!-- 没有会员资格 -->
              <div v-else>
                <p class="price-text price-text_new">
                  <span class="number">{{ newPrice }}</span>
                  <span class="symbol">元</span>
                </p>
                <p class="price-text price-text_vip_small">
                  <span class="number">会员价￥{{ vipPrice }}</span>
                </p>
              </div>
            </div>
            <!-- 没有会员价格 -->
            <div v-else>
              <p class="price-text price-text_new">
                <span class="number">{{ newPrice }}</span>
                <span class="text">元</span>
              </p>
              <p class="price-text price-text_old" v-if="isShowOldPrice">
                <span class="symbol">￥</span>
                <span>{{ oldPrice }}</span>
              </p>
            </div>
          </template>

          <!--身份下的课程-->
          <template v-if="goodsData.usability == 'identity'">
            <p class="price-text price-text_new">
              <span class="text_price">功能包可用</span>
            </p>
          </template>

          <!--免费商品-->
          <template v-if="goodsData.usability == 'free'">
            <p class="price-text price-text_new">
              <span class="text_price">免费</span>
            </p>
          </template>
        </div>
        <div class="right-content">
          <slot />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GoodsButtonPrice',
  props: {
    goodsData: Object,
    unitName: String,
    offlineProduct: Object,
    titleObj: Object,
    currentSpecs: Object,
    productCase: Object,
  },
  computed: {
    // 指定给会员的商品
    isVipGoods() {
      return this.goodsData?.usability === 'membership'
    },
    // 免费会员购买
    isFreeVipBuy() {
      return this.isVipGoods && !!this.goodsData.is_buy_membership
    },
    // 是否可以使用会员价购买
    isVipPricePower() {
      return this.goodsData.is_membership_price
    },
    // 是否有会员价格
    isHasVipPrice() {
      let price = this.currentSpecs?.amount_membership || this.goodsData.product.membership_price
      return !!price && price !== '0.00'
    },
    // 免费商品
    isFreeGoods() {
      return this.goodsData?.usability === 'free'
    },
    newPrice() {
      let price = this.currentSpecs?.amount || this.goodsData.product.price
      return this.$util.clearPriceZero(price)
    },
    oldPrice() {
      let price = this.currentSpecs?.amount_original || this.goodsData.product.o_price
      return this.$util.clearPriceZero(price)
    },
    isShowOldPrice() {
      let price = this.currentSpecs?.amount || this.productCase.price,
        old_price = this.currentSpecs?.amount_original || this.productCase.o_price
      return price !== old_price && old_price != '0.00' && old_price != '0'
    },
    vipPrice() {
      let price = this.currentSpecs?.amount_membership || this.goodsData.product.membership_price
      return this.$util.clearPriceZero(price)
    },
    //商品类型文本
    goodsTypeText() {
      let text = '课程免费学'
      if (this.unitName === 'question') {
        text = '题集免费练习'
      }
      if (this.unitName === 'identity') {
        text = '功能包免费学'
      }
      return text
    },
  },

  data() {
    return {}
  },
  methods: {
    buyVip() {
      this.$emit('clickBuyVip')
    },
  },
}
</script>

<style scoped lang="scss">
.app-advert {
  @include flex_between_center;
  @include maxWidth();
  $height: 2rem;
  padding: 0.25rem 0.53rem 0.7rem;
  height: $height;
  box-sizing: border-box;
  background-color: #fff;

  &-box {
    height: $height;
  }

  &.bottom-fixed {
    z-index: 100;
    position: fixed;
    bottom: 0;
    left: 50%;
    width: 100%;
    max-width: 750px;
    transform: translateX(-50%);
    box-shadow: 0px -3px 4px rgba(0, 0, 0, 0.05);
  }

  .content {
    width: 5rem;
  }

  .right-content {
    flex: 1;
    display: flex;
    justify-content: flex-end;

    .kefu {
      width: 1.1rem;
    }
  }

  .open-button {
    width: 2.77rem !important;
    height: 1rem;
  }
}

.name {
  width: 1.92rem;
  font-size: 0.4rem;
  color: #919499;
  line-height: 0.4rem;
}

.content {
  position: relative;
  display: flex;
  align-items: flex-end;
  flex: 1;
  font-size: 0;

  span {
    font-size: 0.4rem;
    line-height: 0.4rem;
  }

  .icon {
    position: absolute;
    width: 0.5rem;
    top: 0;
    right: 0;
  }

  &.price {
    padding-top: 0.2rem;
  }
}

.price {
  &-text {
    .symbol {
      font-size: 0.35rem;
    }

    .number {
      font-size: 0.42rem;
    }

    &_new {
      color: #ff6a4d;

      .number {
        font-size: 0.59rem;
        font-family: DIN;
        font-weight: bold;
        line-height: 0.6rem;
      }

      .text {
        font-size: 0.29rem;
      }

      .text_price {
        font-size: 0.43rem;
        font-weight: 600;
        line-height: 0.56rem;
      }
    }

    &_old {
      font-size: 0.27rem;
      font-weight: 400;
      line-height: 0.51rem;
      color: #c2c5cc;
      text-decoration: line-through;

      .number,
      .text {
        font-size: 0.27rem;
      }
    }

    &_old_text {
      font-size: 0.27rem;
      font-weight: 400;
      line-height: 0.51rem;
      color: #c2c5cc;

      .number,
      .text {
        font-size: 0.27rem;
      }
    }

    &_vip {
      &_large {
        color: #e5b66e;

        .text {
          font-size: 0.29rem;
          font-weight: 500;
          line-height: 0.56rem;
        }

        .number {
          font-size: 0.59rem;
          font-family: DIN;
          font-weight: bold;
          line-height: 0.75rem;
          color: #e5b66e;
        }
      }

      &_small {
        color: #e5b66e;
        font-weight: 400;

        .number {
          font-size: 0.27rem;
          line-height: 0.51rem;
        }
      }
    }
  }
}
</style>
